import React from "react";
import {
  Wrapper,
  Head,
  Btn,
  Intro,
  YT,
  RedAgentFeatures,
  RedAgentServices,
  AgentBackground,
  AgentImg,
  HeaderMeta,
  RedAgentMeetSection,
  RedAgentMeetForm,
  RedAgentStatsSection,
} from "./elements";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet";
import { useCallback } from "react";
import RedAgentThumbnail from "../../assets/images/red-agent/red-agent-video-bg.png";
import RedAgentF1 from "../../assets/images/red-agent/red-agent-f1.jpg";
import RedAgentF2 from "../../assets/images/red-agent/red-agent-f2.jpg";
import RedAgentF3 from "../../assets/images/red-agent/red-agent-f3.jpg";
import RedAgentPlayIcon from "../../assets/images/dark-agent-play-icon.svg";
import RedAgentMaximize from "../../assets/images/dark-agent-maximize.png";
import RedAgentOptimize from "../../assets/images/dark-agent-optimize.png";
import RedAgentSanitize from "../../assets/images/dark-agent-sanitize.png";
import { useNavigate } from "react-router-dom";
import { CornImg } from "../advisory/AdvisoryElement";
import { CornMobile, ScrollTop } from "../home/HomeElements";
import scrollTopIcon from "../../assets/images/ScrolltoTopIcon.png";
import { FieldRow, FormRow } from "../contactUs/ContactUsElement";
import { Input } from "@mui/material";
import { SpanPolicy } from "../../components/EmailForm/EmailFormElements";
import agent from "../../utils";
import { toast } from "react-toastify";
import { isValidEmail } from "../../helpers/email-helper";
import LogoRedAgent from "../../assets/images/red-agent/red-agent-logo.svg";
import CaptchaDialog from "../../common/captchaDialoge";
import ThanksDialog from "../../common/thanksDialog";
import parse from "html-react-parser";
import { MESSAGES } from "../../constants/messages";
import { FaCheckCircle } from "react-icons/fa";
import ComparisonTable from "../../components/ComparisonTable";
//icon red agent
import IconRedAgent from "../../assets/images/red-agent/icon-red-agent-01.svg";
//icon calendar
import IconCalendar from "../../assets/images/red-agent/icon-red-agent-02.svg";
//icon circle crossed
import IconCircleCrossed from "../../assets/images/red-agent/icon-red-agent-03.svg";
//icon report
import IconReport from "../../assets/images/red-agent/icon-red-agent-04.svg";
//icon connecting people
import IconConnectionPeople from "../../assets/images/red-agent/icon-red-agent-05.svg";
//icon
import Icon06 from "../../assets/images/red-agent/icon-red-agent-06.svg";
//icon alarm
import IconAlarm from "../../assets/images/red-agent/icon-red-agent-07.svg";
//icon check
import IconCheck from "../../assets/images/red-agent/icon-red-agent-08.svg";
//icon signal
import IconSignal from "../../assets/images/red-agent/icon-red-agent-09.svg";
//icon circle arrow up
import IconCircleArrowUp from "../../assets/images/red-agent/icon-red-agent-10.svg";
//icon alert message
import IconAlertMessage from "../../assets/images/red-agent/icon-red-agent-11.svg";
//icon atom
import IconAtom from "../../assets/images/red-agent/icon-red-agent-12.svg";
//icon clock
import IconClock from "../../assets/images/red-agent/icon-red-agent-13.svg";
//icon shield
import IconShield from "../../assets/images/red-agent/icon-red-agent-14.svg";
//icon double cross
import IconDoubleCross from "../../assets/images/red-agent/icon-red-agent-15.svg";
//icon dish
import IconDish from "../../assets/images/red-agent/icon-red-agent-17.svg";
const leftRows = [
  { icon: IconCircleArrowUp, text: "Continuous Verification" },
  { icon: IconDoubleCross, text: "10% False Positives" },
  { icon: IconShield, text: "0% False Negatives" },
  { icon: IconClock, text: "Time to Completion : 7 Hours" },
  { icon: IconAtom, text: "Instant Remediation" },
  { icon: IconAlertMessage, text: "Security Feedback Embedded In Development" },
  {
    icon: IconCircleArrowUp,
    text: "Detects Regressions & Re-introduced Flaws",
  },
  { icon: IconSignal, text: "Real-time, Self-service Reporting Across Teams" },
];

const rightRows = [
  { icon: IconClock, text: "Point-in-Time Testing Manual Penetration Testing" },
  { icon: IconCheck, text: "5% False Positives" },
  { icon: IconAlarm, text: "Human Error Prone" },
  { icon: IconCalendar, text: "Time to Completion : 7 Days" },
  { icon: IconConnectionPeople, text: "Retests Require New Coordination" },
  { icon: IconReport, text: "Findings Age As Code Change" },
  { icon: IconCircleCrossed, text: "Noise in multiple reports" },
  { icon: IconCalendar, text: "1 week ETA for the report, endless standups" },
];

const RED_AGENT_STATS = [
  {
    number: "80%",
    title: "AI Testing",
    label: "AI-Driven Autonomus Pentesting",
  },
  {
    number: "20%",
    title: "Human Expertise",
    label: "Expert-Supervised.<br/> Compliant by Design",
  },
  {
    number: "100%",
    title: "Verification",
    label:
      "Zero Blind Spots.<br/>Real-Time Attack Simulation.<br/>Unlimited Instant Retests",
  },
];

const RedAgentPage = ({ isScrolled, setReshowDialog }) => {
  const isMobile = useMediaQuery({ query: `(max-width: 800px)` });
  const [playVideo, setPlayVideo] = useState(false);
  const targetSection = useSelector((state) => state.scroll.targetSection);
  const navigate = useNavigate();

  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [messageValidation, setMessageValidation] = useState(false);

  const fieldsStyle = { flex: "1 1 auto", marginTop: "3vh" };
  //captcha
  const [loading, setLoading] = useState(false);
  const [captchaKey, setCaptchaKey] = useState(null);
  const [captchaOpen, setCaptchaOpen] = useState(false);
  const [thanksOpen, setThanksOpen] = useState(false);
  const invalidEmailMessage = "Email is not valid";

  const sxProps = {
    "& label.Mui-focused": {
      color: "black",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#002F87",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#002F87",
      },
      "&:hover fieldset": {
        borderColor: "#002F87",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#002F87",
      },
    },
    "& .MuiInputBase-input": {
      width: "100%",
      fontSize: "15px",
    },
  };

  useEffect(() => {
    if (targetSection === null) {
      window.scrollTo(0, 0);
    }
  }, []);

  const submitDemo = () => {
    if (isValidEmail(email)) {
      setIsLoading(true);
      agent.RedAgentDemos.postEmail({
        email: email,
        "g-recaptcha-response": captchaKey,
      })
        .then(() => {
          setEmail("");
          setCaptchaOpen(false);
          toast.success(<>{parse(MESSAGES.SUCCESS.DEMO_FORM_SUBMITTED)}</>);
        })
        .catch(() => {
          toast.error("An error occurred");
        })
        .finally(() => {
          setIsLoading(false);
          setMessageValidation(null);
        });
    } else {
      setMessageValidation(invalidEmailMessage);
    }
  };
  const handleSubmit = () => {
    if (localStorage.getItem("cookie") !== "1") setReshowDialog(true);
    else {
      if (isValidEmail(email)) {
        setCaptchaOpen(true);
      } else {
        setMessageValidation(invalidEmailMessage);
      }
    }
  };
  return (
    <>
      <Helmet>
        <title>The Red Agent</title>
        <meta name="robots" content="nofollow"></meta>
        <meta
          name="description"
          content="Your Ultimate Digital Risk and Threat Intel Ally"
        />
      </Helmet>
      <Wrapper>
        <AgentBackground>
          <AgentImg />
          <HeaderMeta className={"header-meta"}>
            <div className="meta-intro">
              Meet the Red Agent, Our Newest Pentester
            </div>
            <div className="meta-logo-holder">
              <img alt={""} className={"img-fluid"} src={LogoRedAgent} />
              <span>The Red Agent</span>
            </div>
            <div className="meta-body">Never Stop Pentesting</div>
          </HeaderMeta>
          <ScrollTop
            isScrolled={isScrolled}
            src={scrollTopIcon}
            onClick={() => {
              window.scrollTo(0, 0);
            }}
          />
        </AgentBackground>
        <RedAgentMeetSection>
          <CornImg>
            <svg
              width="5vw"
              height="64"
              viewBox="0 0 95 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M93.2442 59.4236C92.3635 60.5719 91.0927 61.5253 89.5607 62.187C88.0286 62.8487 86.29 63.1951 84.5213 63.191H10.7127C8.94399 63.196 7.20501 62.8505 5.67236 62.1895C4.13972 61.5286 2.86799 60.5758 1.98633 59.4279C1.10466 58.2799 0.644456 56.9778 0.652446 55.6537C0.660436 54.3295 1.13634 53.0306 2.03182 51.8887L38.8942 4.16745C39.7767 3.01972 41.0476 2.06639 42.579 1.40351C44.1104 0.740626 45.8481 0.391602 47.617 0.391602C49.386 0.391602 51.1237 0.740626 52.655 1.40351C54.1864 2.06639 55.4574 3.01972 56.3399 4.16745L93.2022 51.8887C94.1045 53.0281 94.584 54.3272 94.5914 55.6518C94.5988 56.9765 94.1337 58.2785 93.2442 59.4236Z"
                fill="url(#paint0_linear_51_664)"
                style={{ mixBlendMode: "normal" }}
              />
              <defs>
                <linearGradient
                  id="paint0_linear_51_664"
                  x1="0.652344"
                  y1="31.7913"
                  x2="94.5915"
                  y2="31.7913"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.253125" stopColor="#bcbcbc" />
                  <stop offset="0.711458" stopColor="#bababa" />
                </linearGradient>
              </defs>
            </svg>
          </CornImg>
          <CornMobile>
            <svg
              width="46"
              height="40"
              viewBox="0 0 46 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M45.3402 37.0986C44.909 37.8203 44.2867 38.4194 43.5365 38.8353C42.7863 39.2511 41.9349 39.4688 41.0689 39.4663H4.92635C4.06024 39.4694 3.2087 39.2522 2.4582 38.8369C1.70769 38.4215 1.08496 37.8227 0.653222 37.1013C0.22149 36.3799 -0.00386255 35.5616 5.00943e-05 34.7294C0.00396274 33.8973 0.237 33.0809 0.675499 32.3633L18.7262 2.37293C19.1584 1.65164 19.7807 1.05252 20.5306 0.635934C21.2805 0.219344 22.1314 0 22.9976 0C23.8638 0 24.7147 0.219344 25.4646 0.635934C26.2145 1.05252 26.8369 1.65164 27.269 2.37293L45.3197 32.3633C45.7615 33.0794 45.9963 33.8958 46 34.7283C46.0036 35.5607 45.7758 36.379 45.3402 37.0986Z"
                fill="url(#paint0_linear_1_662)"
                style={{ mixBlendMode: "normal" }}
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1_662"
                  x1="0"
                  y1="19.7332"
                  x2="46"
                  y2="19.7332"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#bcbcbc" />
                  <stop offset="1" stop-color="#bababa" />
                </linearGradient>
              </defs>
            </svg>
          </CornMobile>
          <div className="row">
            <p className="my-5">
              Red Agent is an AI-driven security tester that scales elite
              hacking techniques to deliver instant results and unlimited
              retests, combining the speed of AI with the wisdom of an expert
              pentester.
              <br />
              <br />
              By understanding key vulnerabilities, new security risks, and the
              emerging vulnerabilities of AI generated code, Red Agent
              application testing in Grey/Black/White-Box continuously analyzes,
              secures and follows business logic to deliver accurate results in
              hours while being able to continuously keep up with code changes.
            </p>
            <YT className={playVideo ? "video-playing" : ""}>
              {!playVideo && (
                <div className="video-thumbnail-wrapper">
                  <img
                    width={"100%"}
                    src={RedAgentThumbnail}
                    alt={""}
                    className={"bg-img img-fluid"}
                  />
                  <img
                    onClick={() => setPlayVideo(true)}
                    src={RedAgentPlayIcon}
                    alt={"play"}
                    className={"play-icon"}
                  />
                </div>
              )}

              {playVideo && (
                <div className={"iframe-holder"}>
                  <iframe
                    style={{ borderRadius: 20 }}
                    width={"100%"}
                    height={"100%"}
                    src="https://www.youtube.com/embed/sYvpM-Z3TWM?autoplay=1"
                    title="The Red Agent"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </div>
              )}
            </YT>

            <CaptchaDialog
              loading={loading}
              open={captchaOpen}
              setOpen={setCaptchaOpen}
              submitHandler={submitDemo}
              btnText={"SUBMIT"}
              setCaptchaKey={setCaptchaKey}
            />
            <ThanksDialog
              open={thanksOpen}
              setOpen={setThanksOpen}
              title={"Thank You For Your Message!"}
            />
            <RedAgentMeetForm>
              <div className="form-title">
                Meet The Red Agent.
              </div>
              <div className="form-comment">
                Leave your email to get a free demo!
              </div>
              <FormRow compact>
                <FieldRow>
                  <Input
                    placeholder="Email"
                    value={email}
                    onChange={(event) => {
                      setEmail(event.target.value?.trim());
                      setMessageValidation(null);
                    }}
                    style={fieldsStyle}
                    sx={sxProps}
                  />
                </FieldRow>
              </FormRow>
              <div className="form-error">{messageValidation ?? ""}</div>
              <div className="form-message">
                By submitting your email address, you agree to receiving emails
                from potech and acknowledge our{" "}
                <SpanPolicy
                  style={{ fontStyle: "normal" }}
                  target="_blank"
                  href="/privacy_notice"
                >
                  Privacy Policy
                </SpanPolicy>
                .
              </div>
              <button
                className="form-button"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                REQUEST DEMO
              </button>
            </RedAgentMeetForm>
          </div>
        </RedAgentMeetSection>
        <RedAgentStatsSection>
          <div className="stats-title">
            AI-Powered Pentesting at Scale
          </div>
          <div className="stats-grid">
            <div className="stats-titles-row">
              {RED_AGENT_STATS.map((stat) => (
                <span key={stat.title} className="stat-circle-title">
                  {stat.title}
                </span>
              ))}
            </div>
            <div className="circles-track">
              {RED_AGENT_STATS.map((stat) => (
                <React.Fragment key={stat.title}>
                  <span className="stat-circle-title mobile-only">
                    {stat.title}
                  </span>
                  <div className="stat-circle">
                    <span className="stat-number">{stat.number}</span>
                  </div>
                  <p className="stat-label mobile-only">
                    {parse(stat.label ?? "")}
                  </p>
                </React.Fragment>
              ))}
            </div>
            <div className="stats-labels-row">
              {RED_AGENT_STATS.map((stat) => (
                <p key={stat.title} className="stat-label">
                  {parse(stat.label ?? "")}
                </p>
              ))}
            </div>
          </div>
        </RedAgentStatsSection>
        <RedAgentFeatures>
          <div className="row">
            <div className="col">
              <div className="title">Easy Provisioning of WEB/API URL</div>
              <div className="description">Fast, secure access managed through a single, intuitive interface spanning URLs, API endpoints, and all types of authentication.</div>
            </div>
            <div className="col">
              <img className="img" alt={""} src={RedAgentF1} />
            </div>
          </div>
          <div className="row reverse">
            <div className="col">
              <div className="title">AI Crawling and Testing</div>
              <div className="description">Automated AI scanning simulates exponential attack scenarios, verifies exploitation, and identifies technical, business layer, and data layer access issues.</div>
            </div>
            <div className="col">
              <img className="img" alt={""} src={RedAgentF2} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="title">
                Compliance ready and agile AI Reporting{" "}
              </div>
              <div className="description">Detect confirmed attacks and vulnerabilities, flag suspicious requests for validation, and verify compliance in real time with on-the-fly testing.</div>
            </div>
            <div className="col">
              <img className="img" alt={""} src={RedAgentF3} />
            </div>
          </div>
        </RedAgentFeatures>
        <RedAgentServices>
          <div className="row">
            <div className="col">
              <div className="title">Edge-Based Security</div>
              <div className="description">
                Operates on an edge-based architecture, prioritizing
                super-secure, zero-data access for customer privacy. Red Agent
                does not have access to customer data, ensuring maximum
                confidentiality.
              </div>
            </div>
            <div className="col">
              <div className="title">Multi-Lingual Support</div>
              <div className="description">
                Facilitates seamless communication with Darkivore’s core engine,
                regardless of language barriers.(English, French, Spanish and
                Arabic in the first pilot).
              </div>
            </div>
          </div>
          <div className="row mt-0">
            <ComparisonTable
              leftTitle="Automated Red Agent"
              leftIcon={IconRedAgent}
              rightTitle="Traditional Pen Testing"
              rightIcon={IconDish}
              leftRows={leftRows}
              rightRows={rightRows}
              showRecommendedBadge
              recommendedBadgeText="Recommended"
              recommendedBadgeIcon={<FaCheckCircle size={16} />}
            />
          </div>

          <RedAgentMeetForm
            width="90vw"
            flexDirection="row"
            padding="50px"
            hasMarginBottom
          >
            <div>
              <div className="form-title">
                Book Your Demo,
                <br /> See It in Action.
              </div>
              <div className="form-comment">
                Leave your email to get a free demo!
              </div>
            </div>
            <div>
              <FormRow compact>
                <FieldRow>
                  <Input
                    placeholder="Email"
                    value={email}
                    onChange={(event) => {
                      setEmail(event.target.value?.trim());
                      setMessageValidation(null);
                    }}
                    style={fieldsStyle}
                    sx={sxProps}
                  />
                </FieldRow>
              </FormRow>
              <div className="form-error">{messageValidation ?? ""}</div>
              <div className="form-message">
                By submitting your email address, you agree to receiving emails
                from potech and acknowledge our{" "}
                <SpanPolicy
                  style={{ fontStyle: "normal" }}
                  target="_blank"
                  href="/privacy_notice"
                >
                  Privacy Policy
                </SpanPolicy>
                .
              </div>
              <button
                className="form-button"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                REQUEST DEMO
              </button>
            </div>
          </RedAgentMeetForm>
        </RedAgentServices>
      </Wrapper>
    </>
  );
};

export default RedAgentPage;
